<template>
<span class="article_btnConsulta">
          <v-snackbar
            v-model="table.snack.show"
            :bottom="null === 'bottom'"
            :left="'right' === 'left'"
            :multi-line="'' === 'multi-line'"
            :right="'right' === 'right'"
            :timeout="table.snack.time"
            :top="null === 'top'"
            :vertical="'' === 'vertical'"
            id="snack"
            :class=" this.table.snack.multiple ? 'snack_multiple' : ''"
            :color="table.snack.color"
        >
            <strong>{{ this.table.snack.text }}</strong>
            <v-btn
            :color="table.snack.btnFColor"
            flat
            @click="table.snack.show = false"
            >
            Fechar
            </v-btn>
        </v-snackbar>
</span>

</template>

<script>
export default {
props: ['table'],
  data: () => ({
  }),
  watch: {
    "table.showSnackAtt": function(oldv, newv) {
      if (this.table.showSnackAtt) {
        var auxTable = this.table;
        setTimeout(function() {
          auxTable.busca = false;
          auxTable.loading = false;
          auxTable.snack.text = "Informações da tabela foram atualizadas";
          auxTable.snackDefault();
          auxTable.snack.show = true;
          auxTable.addedCustomColumn = false;
          auxTable.showSnackAtt = false;
        }, 500);
      }
    }
  },
  
};
</script>
<style scoped>
.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
#btn_consultaAvulsa {
  background-color: #e8e8e8 !important;
}

.article_btnConsulta {
  cursor: help !important;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/snackBar/SnackBar.vue